import styled from "styled-components";

export const Container = styled.form`
  width: 100%;

  label {
    font-size: 24px;
    color: #fff;
    font-weight: 600;
  }

  button[type="submit"] {
    padding: 11px 60px;

    background: white;
    border-radius: 16px;

    width: 100%;

    h1 {
      margin-bottom: initial;
    }
  }
`;
